import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Star, Check, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { listTime } from "@/lib/format";

export const LowRatingsPanel = () => {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data: items = [] } = useQuery({ queryKey: ["low-ratings"], queryFn: () => api.get("/ratings/low").then((r) => r.data), refetchInterval: 15000 });
  const handle = async (id) => {
    try { await api.post(`/ratings/${id}/handle`); qc.invalidateQueries({ queryKey: ["low-ratings"] }); toast.success("Segnato come gestito"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  if (!items.length) return null;
  return (
    <section data-testid="low-ratings-panel" className="fade-up bg-white border border-red-200 rounded-xl overflow-hidden">
      <div className="px-5 py-3 bg-red-50 border-b border-red-200 flex items-center gap-2">
        <AlertTriangle size={16} className="text-red-600" />
        <h3 className="text-sm font-bold text-red-800">Clienti insoddisfatti da ricontattare</h3>
        <span data-testid="low-ratings-count" className="ml-auto text-xs font-bold bg-red-600 text-white rounded-full px-2 py-0.5">{items.length}</span>
      </div>
      <ul className="divide-y divide-slate-100">
        {items.map((r) => (
          <li key={r.id} data-testid={`low-rating-item-${r.id}`} className="px-5 py-3 flex flex-wrap items-center gap-3">
            <span className="flex items-center gap-1 text-xs font-bold text-red-700 bg-red-100 rounded-full px-2.5 py-1"><Star size={12} fill="currentColor" />{r.rating}/5</span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-slate-800 truncate">{r.customer_name}</div>
              <div className="text-xs text-slate-500 truncate">{r.phone} · agente {r.agent_name || "—"} · {listTime(r.created_at)}</div>
            </div>
            <div className="flex gap-2">
              <button data-testid={`low-rating-open-${r.id}`} onClick={() => navigate(`/inbox?c=${r.conversation_id}`)}
                className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg bg-[#0F172A] text-white hover:bg-[#1E293B] transition-colors"><MessageCircle size={13} />Ricontatta</button>
              <button data-testid={`low-rating-handle-${r.id}`} onClick={() => handle(r.id)}
                className="flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition-colors"><Check size={13} />Gestito</button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
